import Card from "app/components/Card";
import { DropdownIcon } from "app/components/Icons";
import { Skeleton } from "app/components/Skeleton";
import clsx from "clsx";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectDraftBoardForm } from "../../../../components/Settings/redux/selector";
import { ticketGroupsActions } from "../../../Tickets/redux/slice";
import { IGroupHeaderMeta, TicketGroup } from "../../../Tickets/types";
import SubGroupLabel from "./SubGroupLabel";
import { useGroupMeta } from "./useGroupMeta";

interface GroupHeaderProps {
  group: TicketGroup;
  loading: boolean;
  subgroupCollapsed: boolean;
  groupIndex: number;
}

const SubGroupHeader: React.FC<GroupHeaderProps> = ({
  group,
  loading,
  subgroupCollapsed,
  groupIndex,
}) => {
  const dispatch = useDispatch();
  const boardFormData = useSelector(selectDraftBoardForm);
  const subGroupBy = boardFormData?.subGroupBy;

  const meta = useGroupMeta(group._id);

  if (loading) {
    return (
      <Card className="rounded-[6px] !p-[10px]">
        <Skeleton className="h-[20px] w-1/2" />
      </Card>
    );
  }
  return (
    <div
      className={clsx(
        "items-center gap-2",
        groupIndex === 0 ? "flex" : "hidden",
      )}
    >
      <button
        className=" flex items-center gap-1 "
        onClick={() => {
          dispatch(
            ticketGroupsActions.toggleSubgroupCollapsed({
              groupId: group._id,
              isCollapsed: !subgroupCollapsed,
            }),
          );
        }}
      >
        <span
          className={clsx(
            "transition-transform duration-200",
            subgroupCollapsed && "-rotate-90",
          )}
        >
          <DropdownIcon size={24} />{" "}
        </span>

        <SubGroupLabel group={group} subGroupBy={subGroupBy} meta={meta as IGroupHeaderMeta} />
      </button>
    </div>
  );
};

export default React.memo(SubGroupHeader);
